"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndexNodeDependencies = void 0;

var _dependenciesNodeGenerated = require("./dependenciesNode.generated.js");

var _dependenciesRangeClassGenerated = require("./dependenciesRangeClass.generated.js");

var _dependenciesSizeGenerated = require("./dependenciesSize.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var IndexNodeDependencies = {
  NodeDependencies: _dependenciesNodeGenerated.NodeDependencies,
  RangeDependencies: _dependenciesRangeClassGenerated.RangeDependencies,
  sizeDependencies: _dependenciesSizeGenerated.sizeDependencies,
  createIndexNode: _factoriesAny.createIndexNode
};
exports.IndexNodeDependencies = IndexNodeDependencies;